import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import LanguagesManager from "./languages/LanguagesManager";
import TranslationSettingsPanel from "./languages/TranslationSettingsPanel";
import TranslationsPanel from "./languages/TranslationsPanel";
import ExternalTemplatesPanel from "./languages/ExternalTemplatesPanel";

/** Iter 156 — Configuración → Idiomas (Fase 1 multidioma). */
export default function SettingsLanguagesTab() {
  const [languages, setLanguages] = useState([]);
  const [settings, setSettings] = useState(null);

  const load = useCallback(async () => {
    try {
      const [l, s] = await Promise.all([api.get("/languages"), api.get("/languages/settings")]);
      setLanguages(l.data || []);
      setSettings(s.data || {});
    } catch (err) { toast.error(formatApiError(err)); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!settings) return <div className="text-sm text-[#525252]">Cargando…</div>;
  return (
    <div className="space-y-6" data-testid="languages-tab">
      <LanguagesManager languages={languages} onChanged={load} />
      <TranslationSettingsPanel settings={settings} languages={languages} onChanged={load} />
      <ExternalTemplatesPanel />
      <TranslationsPanel languages={languages} settings={settings} />
    </div>
  );
}
